import { NotificationsEnum } from '../../../services/api-names';
import {
  HttpBackend,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http';
import { Inject, Injectable, NgZone } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { map } from 'rxjs/operators';
import { Serializer } from '../../../helpers/serializer/seriealizer';
import { Utils } from '../../../utils/utils';
import { TECH_LIB_PORTAL_CONFIG, TechLibPortalConfig } from '../../../tech-lib-portal.interceptor';
import { SessionService } from './../../../services/session.service';

import { NotificationResponseInterface } from '../response/interfaces/notification-response.interface';
import { NotificationResponseModel } from '../response/models/notification-response.model';

@Injectable({
  providedIn: 'root',
})

export class NotificationsService {
  constructor(
    @Inject(TECH_LIB_PORTAL_CONFIG) private config: TechLibPortalConfig,
    private httpBackend: HttpBackend,
    private httpClient: HttpClient,
    private serializer: Serializer,
    private session: SessionService,
    private zone: NgZone
  ) { }

  private updateSession() {
    this.config.sessionToken = this.session.sessionToken;
    this.config.domain = this.session.domain;
    this.config.clientCode = this.session.clientCode;
    this.config.language = this.session.language;

  }

  public getNotificactionData(numElements: number = 20,
    offset: number = 1): Observable<NotificationResponseInterface[]> {
    this.updateSession();

    const url = Utils.formatString(
      this.config.baseApi + NotificationsEnum.api_portal_client_notifications,
      [offset, numElements]
    );

    return new Observable(
      (observer: Observer<NotificationResponseModel[]>) => {
        this.httpClient
          .get<NotificationResponseInterface[]>(url)
          .pipe(
            map((resp: any) => {
              return resp as NotificationResponseModel[];
            })
          )
          .subscribe(
            (resp: any) => {
              observer.next(resp);
              observer.complete();
            },
            (err) => observer.error(err)
          );
      }
    );
  }

  public getNotificationsRead(): Observable<any> {
    this.updateSession();
    return new Observable(
      (observer: Observer<any>) => {
        this.httpClient
          .post<any>(
            this.config.baseApi + NotificationsEnum.api_portal_client_notifications_read, {}
          )
          .pipe(
            map((resp: any) => {
              return resp;
            })
          )
          .subscribe(
            (resp: any) => {
              observer.next(resp);
              observer.complete();
            },
            (err) => observer.error(err)
          );
      }
    );
  }

  public getNotificationsReadId(id: string): Observable<any> {
    this.updateSession();
    return new Observable(
      (observer: Observer<any>) => {
        this.httpClient
          .post<any>(
            Utils.formatString(this.config.baseApi + NotificationsEnum.api_portal_client_notification_idread, [id]), {}
          )
          .pipe(
            map((resp: any) => {
              return resp;
            })
          )
          .subscribe(
            (resp: any) => {
              observer.next(resp);
              observer.complete();
            },
            (err) => observer.error(err)
          );
      }
    );
  }

}
